import { render, staticRenderFns } from "./verify-knowledge-based-answers.vue?vue&type=template&id=f3fcb2b2&"
import script from "./verify-knowledge-based-answers.vue?vue&type=script&lang=ts&"
export * from "./verify-knowledge-based-answers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports